import React, { useEffect, useRef, useState } from "react";

import * as Animate from "./../base/animate";
import * as Delay from "./../base/delay";

import LogoHopeFoundation1x from "./../../media/causes/hope_foundation/bitmap.png";
import LogoHopeFoundation2x from "./../../media/causes/hope_foundation/bitmap@2x.png";
import LogoHopeFoundation3x from "./../../media/causes/hope_foundation/bitmap@3x.png";

import LogoLoveLandFoundation1x from "./../../media/causes/love_land_foundation/bitmap.png";
import LogoLoveLandFoundation2x from "./../../media/causes/love_land_foundation/bitmap@2x.png";
import LogoLoveLandFoundation3x from "./../../media/causes/love_land_foundation/bitmap@3x.png";

import LogoOperationKindness1x from "./../../media/causes/operation_kindness/bitmap.png";
import LogoOperationKindness2x from "./../../media/causes/operation_kindness/bitmap@2x.png";
import LogoOperationKindness3x from "./../../media/causes/operation_kindness/bitmap@3x.png";

import LogoTrevorProject1x from "./../../media/causes/trevor_project/TrevorProject.png";
import LogoTrevorProject2x from "./../../media/causes/trevor_project/TrevorProject@2x.png";
import LogoTrevorProject3x from "./../../media/causes/trevor_project/TrevorProject@3x.png";

import LogoUnicef1x from "./../../media/causes/unicef/Unicef.png";
import LogoUnicef2x from "./../../media/causes/unicef/Unicef@2x.png";
import LogoUnicef3x from "./../../media/causes/unicef/Unicef@3x.png";

import ClutchLogo from "./../../media/awards/clutch-logo.png";
import IndigoLogo from "./../../media/awards/indigo-logo.png";
import ManifestLogo from "./../../media/awards/manifest-logo.png";
//import TSCLogo from "./../../media/awards/tsc-logo.png";
import WebExcellenceLogo from "./../../media/awards/web-excellence-logo.png";
import DrumLogo from "./../../media/awards/drum-logo.png";

import "./../../css/aboutview.css";

const causeDefs = [
   {
      name: "Hope Foundation",
      url: "https://www.projecthopesc.org",
      images: [
         LogoHopeFoundation1x,
         LogoHopeFoundation2x,
         LogoHopeFoundation3x
      ]
   },
   {
      name: "Love Land Foundation",
      url: "https://thelovelandfoundation.org",
      images: [
         LogoLoveLandFoundation1x,
         LogoLoveLandFoundation2x,
         LogoLoveLandFoundation3x
      ]
   },
   {
      name: "Operation Kindness",
      url: "https://www.operationkindness.org",
      images: [
         LogoOperationKindness1x,
         LogoOperationKindness2x,
         LogoOperationKindness3x
      ]
   },
   {
      name: "Trevor Project",
      url: "https://www.thetrevorproject.org/",
      images: [
         LogoTrevorProject1x,
         LogoTrevorProject2x,
         LogoTrevorProject3x
      ]
   },
   {
      name: "Unicef",
      url: "https://www.unicef.org/",
      images: [
         LogoUnicef1x,
         LogoUnicef2x,
         LogoUnicef3x
      ]
   }
];

const awardDefs = [
   {
      name: "Indigo",
      url: "https://www.indigoawards.com/winners/4722",
      image: IndigoLogo
   },
   {
      name: "The Manifest",
      url: "https://themanifest.com/app-development/gaming/companies/dallas",
      image: ManifestLogo
   },
   {
      name: "Clutch",
      url: "https://clutch.co/press-releases/awards-top-b2b-companies-texas-2021",
      image: ClutchLogo
   },
   {
      name: "Web Excellence Awards",
      url: "https://we-awards.com/winner/gm-chevrolet-silveradoev-ar/",
      image: WebExcellenceLogo
   },
   // {
   //    name: "Top Software Companies",
   //    url: "https://topsoftwarecompanies.co/local-firms/ar-app-development",
   //    image: TSCLogo
   // },
   {
      name: "The Drum",
      url: "https://www.thedrum.com/news/2022/12/06/why-marriott-used-digital-screens-teleport-its-hq-lobby-new-climes",
      image: DrumLogo
   }

];

const SourceImageSet = React.forwardRef( ( props, forwardedRef ) => {
   if ( props.images.length > 1 ) {
      return (
         <img ref={ forwardedRef } alt={ props.alt } src={ props.images[ 0 ] } srcSet={
            props.images.map( ( source, index ) => `${ source } ${ index + 1 }x` )
            .join( ", " ) 
         }/>
      );
   }
   else {
      return (
         <img ref={ forwardedRef } alt={ props.alt } src={ props.images[ 0 ] }/>
      );  
   }
} );

const AboutView = React.forwardRef( ( props, forwardedRef ) => {
   const [ intersectionObserver ] = useState( new IntersectionObserver( handle_interaction, {
      root: null,
      rootMargin: "0px",
      threshold: 0.5
   } ) );
   
   /**
    * References to the stats page element.
    */
   const statsRef = useRef( null );
   
   function handle_interaction( entries, observer ) {
      entries.forEach( entry => {
         if ( entry.intersectionRatio > 0 ) {
            observer.unobserve( entry.target );
            
            const categories = Array.from( entry.target.querySelectorAll( ":scope > div" ) );
            
            if ( categories.length > 1 ) {
               const onStep = function onstep( element ) {
                  const p = element.querySelector( ":scope > p:first-of-type" );
                  const plus = p.querySelector( ":scope > span > div" );
                  
                  Animate.transition( plus, "-out" );
                  Animate.transition( p, "-hidden" );
                  // Delay.wait( 0.1 )
                  // .then( () => Animate.transition( p, "-hidden" ) );
               }
               
               const remainingCategories = categories.slice( 1 );
               let index = 0;
               
               const intervalId = setInterval( () => {
                  onStep( remainingCategories[ index ] );
                  
                  index += 1;
                  
                  if ( index >= remainingCategories.length ) {
                     clearInterval( intervalId );  
                  }
               }, 200 );
               
               onStep( categories[ 0 ] );
            }
         }
      } );
   }
   
   useEffect( () => {
      if ( statsRef.current ) {
         const stats = statsRef.current;
         
         intersectionObserver.observe( stats );
         
         return function cleanup() {
            intersectionObserver.unobserve( stats );
         }
      }
   }, [ statsRef ] );
   
   return (
      <div ref={ forwardedRef } className="aboutview">
         <section>
            <div>
               <h2>We Are</h2>
               <p>
                  The Studio for Integrated Intelligence: Creative Vision. Gaming Pedigree. Industry Leading Performance.<br/><br/>

                  We are a cross-functional collective of veteran developers and artists from the world’s leading gaming and tech titans (Nintendo, Ubisoft, Meta, EA Sports), owned by developers. We don't just "experiment" with emerging tech—we harden it into reliable, high-performance tools for the world's top brands.<br/><br/>

                  While our expertise is vast, our approach is modular. Whether you need a singular Agentic AI integration or a global Spatial XR rollout, we deliver Triple-A quality across our core capabilities.

               </p>
            </div>
            
            <div>
               <div>
                  <h3>Our Story</h3>
                  <ul>
                     <li>Founded in 2011</li>
                  </ul>
               </div>
               
               <div>
                  <h3>Headquarters</h3>
                  <ul>
                     <li>Dallas, TX</li>
                  </ul>
               </div>
            </div>
         </section>
         
         {/* <section>
            <h2>we have</h2>
            
            <div ref={ statsRef } className="stats">
               {
                  [
                     [ 160, "Engineering Experience" ],
                     [ 101, "Gaming Experience" ],
                     [ 75, "3D Art Experience" ]
                  ].map( def => (
                     <div key={ def[ 1 ] }>
                        <p className="hidden">{ def[ 0 ] }<span><div className="plus-container out"><div className="plus"></div></div></span></p>
                        <p>{ `Years of Combined ${ def[ 1 ] }` }</p>
                     </div>
                  ) )
               }
            </div>
         </section> */}
         
         <section>
            <h2>causes we support</h2>
            
            <div className="logos">
               {
                  causeDefs.map( def => (
                     <div key={ def.name }>
                        <a href={ def.url }>
                           <SourceImageSet alt={ `${ def.name } Logo` } images={ def.images }/>
                        </a>
                     </div>
                  ) )
               }
            </div>
         </section>
         
         <section>
            <h2>we believe in</h2>
            
            <h3>Integrity in Builds</h3>
            <p>
               Whether it’s a simple web app or a multi-city digital experience, we prioritize industrial-grade stability and technical elegance. By applying the rigorous QA standards of the gaming industry to every project, we ensure "cutting-edge" never comes at the expense of reliability. For our clients, this means a product that works on day one; for our team, it means a culture of craftsmanship over "crunch."
            </p>

            <h3>Radical Cross-Functionality</h3>
            <p>
               Our studio is a vertically integrated engine where producers, artists, and engineers collaborate as a single unit. We believe the best products are born when artists influence logic and engineers inform aesthetics. This "Total Product" approach eliminates the friction between a bold vision and technical reality, offering our team a high-agency environment where diverse expertise is our ultimate competitive advantage.
            </p>

            <h3>Human-Centric Evolution</h3>
            <p>
               We invest in the person to empower the process. We’ve traded corporate optics for genuine professional autonomy, inclusive benefits, and employee-led growth. By sustaining a healthy, stable, and diverse workplace, we ensure our team has the mental runway to master the tools of now and beyond. When our people have the agency to design the careers they envision, our clients receive the passion and precision that only an invested team can deliver.
            </p>
         </section>
         
         <section>
            <h2>awards</h2>
            
            <div className="logos">
               {
                  awardDefs.map( def => (
                     <div key={ def.name }>
                        <a href={ def.url }>
                           <img alt={ `${ def.name } Logo` } src={ def.image }/>
                        </a>
                     </div>
                  ) )
               }
            </div>
         </section>
      </div>
   );
} );

export default AboutView;
